<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_MONTH_ANALYSIS_AMOUNT' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      <astral-button variant="primary" size="small" type="button" icon="excel" labelKey="COMMON.EXCEL" (click)="exportExcel()"></astral-button>
    </div>
  </div>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <app-select
        [control]="form.controls['company']"
        [itemsSource]="companies"
        [multiple]="true"
        [allValue]="'All'"
        [allMode]="'noneEqualsAll'"
      ></app-select>
      <astral-select [control]="form.controls['property']" [itemsSource]="realEstateProperties"></astral-select>
      <astral-select [control]="form.controls['article']" [itemsSource]="articles"></astral-select>
      <astral-select [control]="form.controls['displaySource']" [itemsSource]="displaySelection"></astral-select>
      <astral-select [control]="form.controls['year']" [itemsSource]="yearSelection"></astral-select>
      <astral-select [control]="form.controls['groupLevel']" [itemsSource]="groupSelection"></astral-select>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
      @if (dataContext && dataContext.length) {
        <astral-button
          variant="secondary"
          size="small"
          type="button"
          [labelKey]="!expandAllRows ? 'COMMON.EXPAND_ALL' : 'COMMON.COLLAPSE_ALL'"
          (click)="toggleExpandAllRows()"
        ></astral-button>
      }
    </div>
  </form>

  @if (dataContext) {
    <app-expanded-list-view
      [columnDefinitions]="columnDefinitions"
      [itemsSource]="dataContext"
      [expandAllRows]="expandAllRows"
      [preferencesKey]="'report.month-analysis-amount'"
    ></app-expanded-list-view>
  }
</section>
